// @ts-nocheck

import React from 'react'
import get from 'lodash/get'
import map from 'lodash/map'
import Embed from '../Embed/Embed.index'
import Horoscope from '../Horoscope/Horoscope.index'
import ColunaGiro from '../ColunaGiro'
import { VideoWrap } from 'components/Video'
import ArticleAudioComponent from 'components/ArticleAudio'


import Text from '../Text/Text.index'
import { TextsProps } from './Texts.types'

import { PrensaEngine, ImageGallery } from '@xprog/prensa'
import InfogramEmbed from '../Embed/InfogramEmbed'
import ReadMore from '../ReadMore/ReadMore'


export const EmbedCode = PrensaEngine.styled('div', {
  align: ['column', 'left', 'top'],
  marginBottom: '$12',
  width: '100%'
})

const audioIsActive = process.env.NEXT_PUBLIC_AUDIO_GENERATOR === 'true'

const Texts: React.FC<TextsProps> = (props) => {
  const {
    captionProps,
    componentCaption,
    componentImage: RenderImage,
    itemsAheadBody,
    image: Image,
    images,
    items,
    imageProps,
    siteDomain,
    textProps,
    isViads,
    sourceSite,
    isRestricted,
    audioLink,
    isPosition
  } = props
  // image
  let updatedItems = items

  if (isViads && items && items.length > 0) {
    const totalItems = items.length
    const isEven = totalItems % 2 === 0
    const halfIndex = isEven ? totalItems / 2 : (totalItems - 1) / 2
    const adItem = {
      type: 'p-ads-box',
      bodyParsed: {
        value: 'slotAds',
      },
    }

    updatedItems = [
      ...items.slice(0, halfIndex),
      adItem,
      ...items.slice(halfIndex),
    ]
  } else if (!isViads && items && items.length > 0 && isPosition === 0 && !siteDomain?.includes('cbngoiania.com.br')) {
    const totalItems = items.length
    const isEven = totalItems % 2 === 0
    const halfIndex = isEven ? totalItems / 2 : (totalItems - 1) / 2
    const adItem = {
      type: 'p-viads-box',
      bodyParsed: {
        value: 'slotAds',
      },
    }
    
    updatedItems = [
      ...items.slice(0, halfIndex),
      adItem,
      ...items.slice(halfIndex),
    ]
  }

  const image = get(images, '[0]', false)
  const imageByline = get(image, 'byline', false)
  const imageCaption = get(image, 'caption', false)
  // const imageName = get(image, 'name', false)
  // const linkHref = get(image, 'linkHref', false)
  // const linkTarget = get(image, 'linkTarget', false)
  // const textValue = textName ? `## ${textName}` : false
  const RenderItemsAheadBody = () => {
    return (
      <>
        {map(itemsAheadBody, (item, key) => {
          const bodyParsed = get(item, 'bodyParsed.value', '')
          return <Text {...textProps} value={bodyParsed} key={key} />
        })}
      </>
    )
  }
  const RenderImagesAheadBody = () => {
    return (
      <>
        {image && (
          <Image
            alt={imageCaption}
            byline={imageByline}
            caption={imageCaption}
            componentImage={RenderImage}
            componentCaption={componentCaption}
            captionProps={captionProps}
            isFullWidth={true}
            imageProps={imageProps}
            src={image?.url}
          />
        )}
      </>
    )
  }
  return (
    <>
      <RenderItemsAheadBody />
      <RenderImagesAheadBody />
      {audioIsActive && audioLink?.length > 0 && !isRestricted && (
        <ArticleAudioComponent
          audioLink={audioLink}
        />
      )}
      {map(updatedItems, (item, key) => {
        const imageId = get(item, 'contentData', '')
        const imageURL = get(imageId[0], 'url', '')
        const bodyParsed = get(item, 'bodyParsed.value', '')
        const textName = get(item, 'name', false)
        const bodyCode = get(item, 'code', '')
        const embedCode = get(item, 'code.value', false)
        const galleryList = get(item, 'contentData', [])
        const inputTemplate = get(item, 'inputTemplate', false)
        const slotTemplateCode = get(item, 'slotTemplateCode', false)
        if (
          inputTemplate === 'br.com.atex.templates.articleText.it' ||
          item?.type === 'text'
        ) {
          return <Text key={key} value={bodyParsed} siteDomain={siteDomain} {...textProps} />
        }
        if (inputTemplate === 'br.com.atex.templates.articleEmbed.it' && slotTemplateCode.includes('twitter.com')) {
          return (
            <Embed
              key={key}
              item={item}
            />
          )
        }
        if (inputTemplate === 'br.com.atex.templates.articleEmbed.it' && slotTemplateCode.includes('tiktok.com')) {
          return (
            <Embed
              key={key}
              item={item}
            />
          )
        }
        if (inputTemplate === 'br.com.atex.templates.articleEmbed.it' && slotTemplateCode.includes('infogram.com')) {
          return (
            <InfogramEmbed
              code={slotTemplateCode}
              key={key}

            />
          )
        }
        if (inputTemplate === 'br.com.atex.templates.articleEmbed.it' && slotTemplateCode.includes('instagram.com')) {
          return (
            <Embed
              key={key}
              item={item}
            />
          )
        }
        if (inputTemplate === 'br.com.atex.templates.articleEmbed.it' && slotTemplateCode.includes('facebook.com')) {
          return (
            <Embed
              key={key}
              item={item}
            />
          )
        }
        if (inputTemplate === 'br.com.atex.templates.articleEmbed.it') {
          return (
            <EmbedCode
              dangerouslySetInnerHTML={{ __html: slotTemplateCode }}
              key={key}
            />
          )
        }
        if (inputTemplate === 'br.com.atex.templates.articleGallery.it') {
          return (
            <ImageGallery
              key={key}
              componentCaption={componentCaption}
              captionProps={{
                enabled: true,
                ...captionProps
              }}
              items={galleryList}
              showThumbs={true}
              css={{
                container: {
                  mb: '$4',
                  width: '100%'
                },
                sliderThumbsWrapper: {
                  margin: '0px',
                  width: '100%'
                },
                sliderThumbsAnimated: {
                  align: ['row', 'center', 'middle'],
                  mt: '0px',
                  '.thumb': {
                    height: '67px',
                    width: '67px !important',
                    img: {
                      objectFit: 'cover'
                    }
                  }
                }
              }}
            />
          )
        }
        if (item?.inputTemplate === 'br.com.atex.templates.articleVideo.it') {
          return <VideoWrap alt={`${item.caption} / ${item.byline || 'Reprodução'}`} {...item} key={key} thumbnail={imageURL} />
        }
        if (item?.type === 'embed') {
          return <Embed item={item} key={key} />
        }
        if (item?.type === 'block-horoscope') {
          return <Horoscope key={key} content={item?.bodyParsed?.value}></Horoscope>
        }
        if (item?.type === 'p-readmore-box') {
          return <ReadMore key={key} content={item?.bodyParsed?.value} siteDomain={siteDomain}></ReadMore>
        }
        if (item?.type === 'p-ads-box') {
          switch (sourceSite) {
            case 'opopular.d':
              return <div id='v110250'></div>
            case 'tocantins.d':
              return <div id='v110249'></div>
            case 'daqui.d':
              return <div id='v110251'></div>
          }
        }
        if (item?.type === 'p-viads-box') {
          switch (sourceSite) {
            case 'opopular.d':
              return <div style={{marginBottom: '$2'}} id='v110243'></div>
            case 'tocantins.d':
              return <div style={{marginBottom: '$2'}} id='v110242'></div>
          }
        }
        if (item?.type === 'colunagiro-container') {
          return <ColunaGiro key={key} content={item?.bodyParsed?.value}></ColunaGiro>
        }
        if (item?.type === 'com.atex.standard.image.ImageContentDataBean') {
          const inlineImageByline = get(item, 'byline', false)
          const inlineImageCaption = get(item, 'caption', false)
          return <Image
            alt={inlineImageCaption}
            byline={inlineImageByline}
            caption={inlineImageCaption}
            componentImage={RenderImage}
            componentCaption={componentCaption}
            captionProps={captionProps}
            isFullWidth={true}
            imageProps={imageProps}
            src={item?.url}
            key={key}
          />
        }
        if (!item?.type && item?.images && item?.images.length > 0) {
          const inlineImage = get(item.images, '[0]', false)
          const inlineImageByline = get(inlineImage, 'byline', false)
          const inlineImageCaption = get(inlineImage, 'caption', false)
          return <Image
            alt={inlineImageCaption}
            byline={inlineImageByline}
            caption={inlineImageCaption}
            componentImage={RenderImage}
            componentCaption={componentCaption}
            captionProps={captionProps}
            isFullWidth={true}
            imageProps={imageProps}
            src={inlineImage?.url}
            key={key}
          />
        }
        return <Text key={key} value={bodyParsed} {...textProps} />
      })}
    </>
  )
}

Texts.defaultProps = {}

export default Texts
